import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UploadScormDialog_CreateScormCourseMutationVariables = Types.Exact<{
  s3Key: Types.Scalars['String']['input'];
  packageName: Types.Scalars['String']['input'];
}>;


export type UploadScormDialog_CreateScormCourseMutation = { __typename?: 'Mutation', createSCORMCourseLibraryItem: { __typename?: 'SCORMCourseMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, scormCourse?: { __typename?: 'SCORMCourse', libraryItem: { __typename?: 'LibraryItem', id: string } } | null } };


export const UploadScormDialog_CreateScormCourseDocument = gql`
    mutation UploadSCORMDialog_CreateSCORMCourse($s3Key: String!, $packageName: String!) {
  createSCORMCourseLibraryItem(s3Key: $s3Key, packageName: $packageName) {
    success
    error {
      code
    }
    scormCourse {
      libraryItem {
        id
      }
    }
  }
}
    `;
export type UploadScormDialog_CreateScormCourseMutationFn = Apollo.MutationFunction<UploadScormDialog_CreateScormCourseMutation, UploadScormDialog_CreateScormCourseMutationVariables>;

/**
 * __useUploadScormDialog_CreateScormCourseMutation__
 *
 * To run a mutation, you first call `useUploadScormDialog_CreateScormCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadScormDialog_CreateScormCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadScormDialogCreateScormCourseMutation, { data, loading, error }] = useUploadScormDialog_CreateScormCourseMutation({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *      packageName: // value for 'packageName'
 *   },
 * });
 */
export function useUploadScormDialog_CreateScormCourseMutation(baseOptions?: Apollo.MutationHookOptions<UploadScormDialog_CreateScormCourseMutation, UploadScormDialog_CreateScormCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadScormDialog_CreateScormCourseMutation, UploadScormDialog_CreateScormCourseMutationVariables>(UploadScormDialog_CreateScormCourseDocument, options);
      }
export type UploadScormDialog_CreateScormCourseMutationHookResult = ReturnType<typeof useUploadScormDialog_CreateScormCourseMutation>;
export type UploadScormDialog_CreateScormCourseMutationResult = Apollo.MutationResult<UploadScormDialog_CreateScormCourseMutation>;
export type UploadScormDialog_CreateScormCourseMutationOptions = Apollo.BaseMutationOptions<UploadScormDialog_CreateScormCourseMutation, UploadScormDialog_CreateScormCourseMutationVariables>;